import { environment } from 'src/environments/environment'
import {
  AccessRights,
  UserRole
} from 'src/app/features/role/user-role/user-role'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { configurationOptionSelectors } from 'src/app/features/configuration-option/configuration-option.selectors'
import { combineLatest, Observable, of } from 'rxjs'
import {
  catchError,
  distinctUntilChanged,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { Component, Input, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'
import { ConfigurationOptionService } from '../configuration-option.service'
import { NotificationService } from 'src/app/core/notification.service'
import { ISO4217CurrencyCodes } from 'src/app/shared/utils/currencyCodes'
import { TranslatorService } from 'src/app/core/translator.service'
import { configurationOptionActions } from '../configuration-option.actions'
import { Actions, ofType } from '@ngrx/effects'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
@UntilDestroy()
@Component({
  selector: 'site-settings-category-description-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SiteSettingsCategoryDescriptionTabComponent implements OnInit {
  @Input() isCollapsed: any = true
  @Input() siteId: number
  public isLoading$: Observable<boolean>
  public ISO4217CurrencyCodes = Object.values(ISO4217CurrencyCodes)
  public form: UntypedFormGroup
  public configurationSiteSettingsCategoriesEn$: Observable<any>
  public configurationSiteSettingsCategoriesNl$: Observable<any>
  public configurationSiteSettingsCategoriesFr$: Observable<any>
  public configurationSiteSettingsCategoriesDe$: Observable<any>
  public configOptions$: Observable<any>
  public formValues: any
  public formControlsEn: any
  public formControlsNl: any
  public formControlsFr: any
  public formControlsDe: any
  public currentUserRole$: Observable<UserRole>
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private configOptionService: ConfigurationOptionService,
    private notificationService: NotificationService,
    private translatorService: TranslatorService,
    private actions$: Actions
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      en_category0desc: [],
      en_category1desc: [],
      en_category2desc: [],
      en_category3desc: [],
      en_category4desc: [],
      en_category5desc: [],
      en_category6desc: [],
      en_category7desc: [],
      en_category8desc: [],
      en_category9desc: [],
      nl_category0desc: [],
      nl_category1desc: [],
      nl_category2desc: [],
      nl_category3desc: [],
      nl_category4desc: [],
      nl_category5desc: [],
      nl_category6desc: [],
      nl_category7desc: [],
      nl_category8desc: [],
      nl_category9desc: [],
      de_category0desc: [],
      de_category1desc: [],
      de_category2desc: [],
      de_category3desc: [],
      de_category4desc: [],
      de_category5desc: [],
      de_category6desc: [],
      de_category7desc: [],
      de_category8desc: [],
      de_category9desc: [],
      fr_category0desc: [],
      fr_category1desc: [],
      fr_category2desc: [],
      fr_category3desc: [],
      fr_category4desc: [],
      fr_category5desc: [],
      fr_category6desc: [],
      fr_category7desc: [],
      fr_category8desc: [],
      fr_category9desc: [],
      en_category0_explanation: [],
      en_category1_explanation: [],
      en_category2_explanation: [],
      en_category3_explanation: [],
      en_category4_explanation: [],
      en_category5_explanation: [],
      en_category6_explanation: [],
      en_category7_explanation: [],
      en_category8_explanation: [],
      en_category9_explanation: [],
      nl_category0_explanation: [],
      nl_category1_explanation: [],
      nl_category2_explanation: [],
      nl_category3_explanation: [],
      nl_category4_explanation: [],
      nl_category5_explanation: [],
      nl_category6_explanation: [],
      nl_category7_explanation: [],
      nl_category8_explanation: [],
      nl_category9_explanation: [],
      de_category0_explanation: [],
      de_category1_explanation: [],
      de_category2_explanation: [],
      de_category3_explanation: [],
      de_category4_explanation: [],
      de_category5_explanation: [],
      de_category6_explanation: [],
      de_category7_explanation: [],
      de_category8_explanation: [],
      de_category9_explanation: [],
      fr_category0_explanation: [],
      fr_category1_explanation: [],
      fr_category2_explanation: [],
      fr_category3_explanation: [],
      fr_category4_explanation: [],
      fr_category5_explanation: [],
      fr_category6_explanation: [],
      fr_category7_explanation: [],
      fr_category8_explanation: [],
      fr_category9_explanation: []
    })
    this.formControlsEn = Object.keys(this.form.controls).filter(
      (f) => f.includes('en_category') && f !== 'en_category0desc'
    )
    this.formControlsNl = Object.keys(this.form.controls).filter(
      (f) => f.includes('nl_category') && f !== 'nl_category0desc'
    )
    this.formControlsFr = Object.keys(this.form.controls).filter(
      (f) => f.includes('fr_category') && f !== 'fr_category0desc'
    )
    this.formControlsDe = Object.keys(this.form.controls).filter(
      (f) => f.includes('de_category') && f !== 'de_category0desc'
    )

    this.currentUserRole$ = this.store.select(
      persistentUserRoleSelectors.selectSelectedUserRole
    )
    this.configurationSiteSettingsCategoriesEn$ = combineLatest([
      this.store
        .select(configurationOptionSelectors.selectAll)
        .pipe(map((c) => c.filter((c) => c.key.includes('en_category')))),
      this.currentUserRole$
    ]).pipe(
      map(([configOptionEn, currentUserRole]) =>
        configOptionEn.filter((c) => c.siteId == currentUserRole?.siteId)
      )
    )
    this.configurationSiteSettingsCategoriesNl$ = combineLatest([
      this.store
        .select(configurationOptionSelectors.selectAll)
        .pipe(map((c) => c.filter((c) => c.key.includes('nl_category')))),
      this.currentUserRole$
    ]).pipe(
      map(([configOptionNl, currentUserRole]) =>
        configOptionNl.filter((c) => c.siteId == currentUserRole?.siteId)
      )
    )

    this.configurationSiteSettingsCategoriesFr$ = combineLatest([
      this.store
        .select(configurationOptionSelectors.selectAll)
        .pipe(map((c) => c.filter((c) => c.key.includes('fr_category')))),
      this.currentUserRole$
    ]).pipe(
      map(([configOptionFr, currentUserRole]) =>
        configOptionFr.filter((c) => c.siteId == currentUserRole?.siteId)
      )
    )
    this.configurationSiteSettingsCategoriesDe$ = combineLatest([
      this.store
        .select(configurationOptionSelectors.selectAll)
        .pipe(map((c) => c.filter((c) => c.key.includes('de_category')))),
      this.currentUserRole$
    ]).pipe(
      map(([configOptionDe, currentUserRole]) =>
        configOptionDe.filter((c) => c.siteId == currentUserRole?.siteId)
      )
    )

    this.configOptions$ = combineLatest([
      this.configurationSiteSettingsCategoriesEn$,
      this.configurationSiteSettingsCategoriesNl$,
      this.configurationSiteSettingsCategoriesFr$,
      this.configurationSiteSettingsCategoriesDe$
    ]).pipe(
      map(([enCat, nlCat, frCat, deCat]) => {
        return nlCat.concat(enCat).concat(frCat).concat(deCat)
      })
    )
    this.configOptions$
      .pipe(
        untilDestroyed(this),
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b))
      )
      .subscribe((configOptions) => {
        this.formValues =
          this.configOptionService.mapEntitiesToObject(configOptions)
      })
  }

  public onFormSubmit(): void {
    if (!this.form.valid) {
      return
    }

    this.store.dispatch(
      configurationOptionActions.updateOrCreateManyInBulk({
        form: this.form.value
      })
    )

    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(5000),
        catchError((error) => of(null))
      )
      .subscribe((action) => {
        if (!action) {
          return
        }

        this.notificationService.emit('alerts.success', 'success')
      })
  }
}
